import {
  CREATE_PUBLIC_MANUAL_PAYMENT_INTENT,
  CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_SUCCESS,
  CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_FAILURE,
  RESET_PUBLIC_MANUAL_PAYMENT_INTENT,
} from "./actionType";

export const createPublicManualPaymentIntent = (payload) => ({
  type: CREATE_PUBLIC_MANUAL_PAYMENT_INTENT,
  payload,
});

export const createPublicManualPaymentIntentSuccess = (payload) => ({
  type: CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_SUCCESS,
  payload,
});

export const createPublicManualPaymentIntentFailure = (payload) => ({
  type: CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_FAILURE,
  payload,
});

export const resetPublicManualPaymentIntent = () => ({
  type: RESET_PUBLIC_MANUAL_PAYMENT_INTENT,
});
